import { postSubscribe } from '@cbhq/cdx-api';
import { useLogger, useDeploymentTargetContext, ActionBanner as ActionBanner$1 } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { CONTENTFUL_COMPONENTS_STYLE_MAP } from './contentToPropsMap.js';
import { jsx } from 'react/jsx-runtime';
const ACTION_BANNER_CONTENT_MODEL_ID = 'cdxActionBannerFull';
const positionMap = {
  '50-50-left': 'left',
  '50-50-right': 'right',
  Full: 'stacked'
};
function ActionBanner({
  layout: layoutProp,
  style,
  media,
  headline: title,
  subhead: body,
  anchor,
  hasSpacingTop = true,
  options,
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  link,
  ctaType,
  formSettings,
  hasSpacingVertical
}) {
  const contentStyle = CONTENTFUL_COMPONENTS_STYLE_MAP[style];
  const layout = positionMap[layoutProp];
  const _ref = formSettings?.fields || {},
    submitButtonLabel = _ref.submitButtonLabel,
    productId = _ref.productId,
    placeholder = _ref.placeholder,
    successMessage = _ref.successMessage,
    formType = _ref.formType;
  const _useLogger = useLogger(),
    notifyError = _useLogger.notifyError;
  const _useDeploymentTargetC = useDeploymentTargetContext(),
    deploymentTargetName = _useDeploymentTargetC.deploymentTargetName;
  const _country$localeCode$c = {
      country: 'US',
      localeCode: 'en',
      currency: 'USD'
    },
    country = _country$localeCode$c.country,
    localeCode = _country$localeCode$c.localeCode,
    currency = _country$localeCode$c.currency;

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const onSubmit = async email => {
    if (!productId && !options.productId) return false;
    const result = await postSubscribe({
      email,
      countryCode: country,
      locale: localeCode,
      currency,
      productId: productId || options.productId,
      isProd: deploymentTargetName === 'production',
      onError: notifyError
    });
    return result;
  };
  const linkProps = link && mapEntryLink(link);
  if (ctaType === 'form') return /*#__PURE__*/jsx(ActionBanner$1, {
    style: contentStyle,
    layout: layout,
    mediaUrl: media?.fields.file.url,
    mediaAlt: media?.fields.title,
    headline: title,
    body: body,
    placeholder: placeholder || 'Enter your email' // TODO: Use microcopies as fallback values
    ,

    successMessage: successMessage || 'Thanks for subscribing!',
    submitButtonLabel: submitButtonLabel || 'Submit',
    onSubmit: onSubmit,
    ctaType: "form",
    hasSpacingTop: hasSpacingTop,
    anchor: anchor,
    hasSpacingVertical: hasSpacingVertical,
    formType: formType
  });
  return /*#__PURE__*/jsx(ActionBanner$1, {
    style: contentStyle,
    layout: layout,
    mediaUrl: media?.fields.file.url,
    mediaAlt: media?.fields.title,
    headline: title,
    body: body,
    ctaType: "links",
    ctaButtonLabel: linkProps?.label || ctaButtonLabel,
    ctaButtonUrl: linkProps?.url || ctaButtonUrl,
    secondaryButtonLabel: secondaryButtonLabel,
    secondaryButtonUrl: secondaryButtonUrl,
    hasSpacingTop: hasSpacingTop,
    hasSpacingVertical: hasSpacingVertical
  });
}
export { ACTION_BANNER_CONTENT_MODEL_ID, ActionBanner, positionMap };
//# sourceMappingURL=ActionBanner.js.map
